import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import CustomTable from "../../../../widgets/table/index";
import HeaderSection from "../../../common/headerSection";
import PageHeader from "../../../common/pageHeader";
import {
  columns,
  opColumns,
  activityFrequencyColumns,
} from "./partials/columns";
import { scheduleService } from "../../../../service/scheduleService";
import Pagination from "../../../../widgets/pagination";
import { Button, Modal } from "react-bootstrap";
import { TfiClose } from "react-icons/tfi";
import AlertModal from "../../../../widgets/alertModal";
import CustomToast from "../../../../widgets/toaster";
import { userService } from "../../../../service/userService";
import { useTranslation } from "react-i18next";
import { gradeTypes } from "../../../../service/gradeType";
import { helperFunctions as _h, helperFunctions } from "../../../../utils/helper";
import baseUrl from "../../../../service";
import { ALLOW_CUSTOM_DATE, DEFAULT_PAGE_SIZE } from "../../../../constants/constants";
import ViewSchedule from "./partials/viewSchedule";
import CustomLoader from "../../../../widgets/loader/loader";
import { areaService } from "../../../../service/areaServices";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Checkbox, ListItemText } from "@mui/material";
import { FIELD_VALIDATIONS } from "../../../../constants/fieldValidations";

const ScheduleProduction2 = () => {
  const { t } = useTranslation();

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD
  const date7DaysAgo = new Date();
  date7DaysAgo.setDate(date7DaysAgo.getDate() - 7);
  const formattedDate7DaysAgo = date7DaysAgo.toISOString().split("T")[0];

  const formattedTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
  const dateTime = `${formattedDate7DaysAgo} 00:00:00`;

  // end date should be 1 week ahead from currentDate
  const endDate = new Date(currentDate);
  const formattedEndDate = endDate.toISOString().split('T')[0]; // YYYY-MM-DD
  const formattedEndTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
  const endDateTime = `${formattedEndDate} 23:59:59`;

  const defaultFormData : any = {
    id: "",
    activity_type_id: "",
    reason: "",
    status: "",
    created_at: "",
    updated_at: "",
    created_by: "",
    updated_by: "",
    activity_type_name: "",
    area_grade_name: "",
    production_schedule_name: "",
    product_name: "",
    product_id: "",
    production_type: "",
    area_id: [],
    from_date_time: moment(formattedDate).format("DD-MM-YYYY - HH:mm:ss"),
    to_date_time: moment(formattedDate).format("DD-MM-YYYY - HH:mm:ss"),
    area_name: "",
    areaType: "",
    gradeType: "",
  };
  const [tableData, setTableData] = useState<Array<any>>([{ loading: true }]);
  const [useEffectRequired, setUseEffectRequired] = useState(false);

  // table pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const [keyWord, setkeyWord] = useState("");
  const [fromDate, setFromDate] = useState(dateTime);
  const [toDate, setToDate] = useState(endDateTime);
  const [productionType, setProductionType] = useState("");
  const [areaId, setAreaId] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddConfirmationAlert, setShowAddConfirmationAlert] =
    useState(false);
  const [statusChangeAlert, setStatusChangeAlert] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(defaultFormData);
  const [showViewSchedule, setShowViewSchedule] = useState(false);
  const [tab, setTab] = useState("1")

  //toaster section
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [errors, setErrors] = useState<Errors>({});
  const [userId, setUserId] = useState<number>(0);
  const sortRemoveList=["from_date_time","to_date_time","is_completed"]
  const [productionStatus, setProductionStatus] = useState("");
 

  //handle error section
  interface Errors {
    id?: string;
    activity_type_id?: string;
    reason?: string;
    status?: string;
    created_at?: string;
    updated_at?: string;
    created_by?: string;
    updated_by?: string;
    activity_type_name?: string;
    area_grade_name?: string;
    production_schedule_name?: string;
    product_name?: string;
    production_type?: string;
    area_id?: string;
    from_date_time?: string;
    to_date_time?: string;
    area_name?: string;
    batchId?: string;
    lotId?: string;
    nextSerialNo?: string;
    plateCount?: string;
    areaType?: string;
    gradeType?: string;
  }
  const [masterFormData, setMasterFormData] = useState(defaultFormData);
  const [modalName, setModalName] = useState("");
  const [updatedStatus, setUpdatedStatus] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [permission, setPermission] = useState<any>([]);
  const [activityType, setActivityType] = useState<Array<any>>([]);
  const [areaList, setAreaList] = useState<Array<any>>([]);
  const [areaType, setTypeList] = useState<Array<any>>([]);
  const [grade, setGrade] = useState<Array<any>>([]);
  const [productList, setProductList] = useState<Array<any>>([]);


  const defaultQrFormData = {
    id: "",
    activity_type_id: "",
    batchId: "",
    lotId: "",
    nextSerialNo: "",
    plateCount: "",
  };

  const [showGenerateQrModal, setShowGenerateQrModal] = useState(false);
  // table pagination
  const [opPage, setOpPage] = useState(1);
  const [opPageSize, setOpPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [opTotalPages, setOpTotalPages] = useState(0);
  const [opTotalElements, setOpTotalElements] = useState(0);
  const [opTableData, setOpTableData] = useState<Array<any>>([]);
  const [qrFormData, setQrFormData] = useState(defaultQrFormData);
  const [batchList, setBatchList] = useState<Array<any>>([]);
  const [lotList, setLotList] = useState<Array<any>>([]);
  const [totalPlateCount, setTotalPlateCount] = useState(0);
  const [selectedOpSlNo, setSelectedOpSlNo] = useState<Array<any>>([]);
  const [cellWidth, setCellWidth] = useState(1);
  const [qrModalShow, setQrModalShow] = useState(false);
  const [selectedSlnoLen, setSelectedSlnoLen] = useState(0);
  const [qrFiles, setQrFiles] = useState<string[]>([]);
  const [selectedOperatorIds, setSelectedOperatorIds] = useState([]);
  const [loader, setLoader] = useState(false);
  const [locationList, setLocationList] = useState([]);
  // const [tab, setTab] = useState("1")


  const [frequencyPreviewTableData, setFrequencyPreviewTableData] = useState<
    Array<any>
  >([]);

  const allAreaNames = useMemo(() => areaList.map((val: any) => val.id), [areaList]);

  const isAllSelected = useMemo(() => {
    return masterFormData.area_id.length === allAreaNames.length;
  }, [masterFormData.area_id, allAreaNames, areaList]);

  //handle user details for submit handling
  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");
    if (storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id);
      getPermissionByRole(storedObject[0].role_master_id);
    }
    getActivityTypeList();
    getAreaList("8,12,9,6,17", "");
    getProductList();
    getProductionScheduleList();
    setUseEffectRequired(false);
    setFrequencyPreviewTableData([]);
    geAreaTypeList();
    listGrade();
  }, [useEffectRequired]);

  //get permission by role
  const getPermissionByRole = async (role: number) => {
    try {
      const response = await userService.getPermissionByRole(role);
      if (response.status && response.statusCode === 200) {
        setPermission(response.data.permissions);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getFrequencyPreviewTableData = async (data: any) => {
    try {
      const response = await scheduleService.check_area_activity_frequencies(
        data
      );
      if (response.status && response.statusCode === 200) {
        let columns: any = [];
        Object.values(response.data).forEach((val: any, index: any) => {
          let critical_frequency = "NA";
          let noncritical_frequency = "NA";
          let activity_frequencies_id = "NA";
          let location_name = "NA";
          let locationCategoryC = "NA";
          let locationCategoryD = "NA";
          // let activity_workflow_definition_name = "NA";
          if (_h.arrayHasData(val?.activity_frequencies)) {
            Object.values(val?.activity_frequencies).forEach((frq: any) => {
              activity_frequencies_id = frq.id
              // activity_workflow_definition_name = frq.activity_workflow_definition_name
              location_name = frq.location_name
              let freq =
                "Once in every " +
                frq?.frequency_period +
                " " +
                frq?.frequency
                  .replace("Hourly", "Hour")
                  .replace("Daily", "Day")
                  .replace("Weekly", "Week")
                  .replace("Monthly", "Month")
                  .replace("Yearly", "Year");
              // frq?.frequency + " " + frq?.frequency_period + " " + "Times";
              if (_h.arrayHasData(frq?.day)) {
                freq += " / " + frq?.day.join(", ");
              }
              if (_h.arrayHasData(frq?.week)) {
                freq += " / " + "Week- " + frq?.week.join(", ");
              }
              if (_h.arrayHasData(frq?.month)) {
                freq += " / " + frq?.month.join(", ");
              }
              if (frq?.location_category_id == 1) {
                critical_frequency = freq; //A
              }
              if (frq?.location_category_id == 2) {
                noncritical_frequency = freq; //B
              }
              if (frq?.location_category_id == 3) {
                locationCategoryC = freq; //C
              }
              if (frq?.location_category_id == 4) {
                locationCategoryD = freq; //D
              }
            });
          }
          columns.push({
            id: activity_frequencies_id,
            slno: index + 1,
            name: val?.name,
            location_name: location_name,
            // activity_workflow_definition_name: activity_workflow_definition_name,
            critical_frequency: critical_frequency,
            noncritical_frequency: noncritical_frequency,
            locationCategoryC: locationCategoryC,
            locationCategoryD: locationCategoryD
          });
        });
        setFrequencyPreviewTableData(columns);
      } else {
        setFrequencyPreviewTableData([]);
      }
    } catch (error) {
      setFrequencyPreviewTableData([]);
      console.error(error);
    }
  };

  //handle onchange input fields
  const handleFieldOnChange = (e: any) => {
    const { name, value } = e.target;
    
    // Clear any previous errors when user starts typing
    if (errors[name as keyof Errors]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }

    // Limit production_schedule_name to 50 characters
    if (name === "production_schedule_name" && value.length > FIELD_VALIDATIONS.LOCATION_NAME.MAX_LENGTH) {
      setErrors(prev => ({
        ...prev,
        production_schedule_name: FIELD_VALIDATIONS.LOCATION_NAME.ERROR_MESSAGE
      }));
      return;
    }

    if (name == "area_id") {
      let area = areaList.filter((val) => value == val?.id);
      if (_h.arrayHasData(area) && _h.objectHasValue(area[0])) {
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          area_grade_name: area[0]?.grade_name,
        }));
      } else {
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          area_grade_name: "",
        }));
      }
    }
    if (name == "product_name") {
      let productName = productList.filter((val) => value == val?.name);
      if (_h.arrayHasData(productName) && _h.objectHasValue(productName[0])) {
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          product_id: productName[0]?.id,
        }));
      } else {
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          product_id: "",
        }));
      }
    }
    if (name == "from_date_time" && _h.isNotEmpty(value)) {
      if (moment(value, "YYYY-MM-DD").format("DD-MM-YYYY") > masterFormData.to_date_time) {
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          to_date_time: "",
        }));
      }
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        from_date_time: moment(value, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
      }));
    } else if (name == "to_date_time" && _h.isNotEmpty(value)) {
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        to_date_time: moment(value, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
      }));
    } else {
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
    if (name == "production_type" || name == "area_id") {
      if (name == "area_id") {
        // getFrequencyPreviewTableData({
        //   area_id: value,
        //   production_type: masterFormData?.production_type,
        //   sort: sort,
        //   order: order
        // });
        getListLocation(value)
      } else if (name == "production_type") {
        // getFrequencyPreviewTableData({
        //   production_type: value,
        //   area_id: masterFormData?.area_id,
        //   sort: sort,
        //   order: order
        // });
      } else {
        setFrequencyPreviewTableData([]);
      }
    }    
    if (name == "areaType" || name == "gradeType") {
      if (name == "areaType") {
        getAreaList(value, masterFormData.gradeType || "");
      } else if (name == "gradeType") {
        getAreaList(masterFormData.areaType, value);
      }
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        area_grade_name: "",
        area_id: []
      }));
      setLocationList([]);
    }

  };

  //api call to get the area type drop down
    const geAreaTypeList = async () => {
      try {
        const response = await areaService.geAreaDropDownList();
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    title: element.type_name,
                    id: element.type_code,
                    status: element.status,
                  };
                }
              );
              setTypeList(rowData);
            }
          } catch (error) {
          }
        }
      } catch (error) {
        console.error("area response", error);
      }
  };

   // list grade options
  const listGrade = async () => {
    try {
      const response = await gradeTypes.listGradeOptions();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            // setTotalPages(response?.totalPages);
            // setTotalElements(response?.totalElements);
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  grade: element.grade,
                  id: element.id,
                };
              }
            );
            setGrade(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //clear modal on close
  const handleFormClose = () => {
    setShowAddModal(false);
    setErrors({});
    setMasterFormData(defaultFormData);
    setAreaList([]);
    setLocationList([]);
    getAreaList("8,12,9,6,17", "");
  };

  //handle area validation starts here
  const handleFormValidation = () => {
    const errors: Errors = {};
    // if (!masterFormData.activity_type_id) {
    //   errors.activity_type_id = "Please select activity type";
    // }
    if (!masterFormData.production_schedule_name) {
      errors.production_schedule_name = t("scheduleProduction.errors.scheduleName");
    } else if (masterFormData.production_schedule_name.length > 50) {
      errors.production_schedule_name = "Production Schedule Name cannot exceed 50 characters";
    }
    // if (!masterFormData.product_name) {
    //   errors.product_name = t("scheduleProduction.errors.productName");
    // }

    // Product name is required only when production type is "operational"
  if (masterFormData.production_type === "operational" && !masterFormData.product_name) {
    errors.product_name = t("scheduleProduction.errors.productName");
  }
    if (!masterFormData.production_type) {
      errors.production_type = t("scheduleProduction.errors.producType");
    }
    if (masterFormData.area_id.length < 1) {
      errors.area_id = t("scheduleProduction.errors.area");
    }
    if (!masterFormData.areaType) {
      errors.areaType = t("scheduleProduction.errors.areaType");
    }
    if (!masterFormData.gradeType) {
      errors.gradeType = t("scheduleProduction.errors.gradeType");
    }
    if (!masterFormData.from_date_time) {
      errors.from_date_time = t("scheduleProduction.errors.fromDate");
    }
    if (!masterFormData.to_date_time) {
      errors.to_date_time = t("scheduleProduction.errors.toDate");
    }
    // if (
    //   _h.isNotEmpty(masterFormData.from_date_time) &&
    //   _h.isNotEmpty(masterFormData.to_date_time)
    // ) {
    //   let fromEpoch = new Date(masterFormData.from_date_time).valueOf();
    //   let toEpoch = new Date(masterFormData.to_date_time).valueOf();
    //   if (fromEpoch >= toEpoch) {
    //     errors.from_date_time = "From date should be less than To date";
    //     errors.to_date_time = "To date should be greater than From date";
    //   }
    // }

    if (masterFormData.id && !masterFormData.reason) {
      errors.reason = t("scheduleProduction.errors.edit");
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setShowAddConfirmationAlert(true);
    setErrors({});
  };

  //handle add area submit api call
  const handleFormSubmit = async () => {
    setLoader(true)
    const dataToSend = {
      // schedule_frequency_ids: frequencyPreviewTableData.map(item => item.id).join(','),
      id: masterFormData.id,
      production_schedule_name: masterFormData.production_schedule_name,
      product_name: masterFormData.product_name,
      product_id: masterFormData.product_id,
      production_type: masterFormData.production_type,
      area_id: masterFormData.area_id,
      activity_type_id: masterFormData.activity_type_id,
      from_date_time: _h.isNotEmpty(masterFormData.from_date_time)
        ? moment(masterFormData.from_date_time, "DD-MM-YYYY - HH:mm:ss").format(
          "YYYY-MM-DD HH:mm:ss"
        )
        : "",
      to_date_time: _h.isNotEmpty(masterFormData.to_date_time)
        ? moment(masterFormData.to_date_time, "DD-MM-YYYY - HH:mm:ss").format(
          "YYYY-MM-DD 23:59:59"
        )
        : "",
      interface_name: "Production Schedule",
      reason: masterFormData.reason,
    };

    try {
      const response = await scheduleService.createScheduleProduction(
        dataToSend
      );
      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setLoader(false)
        setToastMessage(response.message);
        getProductionScheduleList();
        handleFormClose();
      } else {
        setToastType("error");
        setLoader(false)
        setToastMessage(response.message);
      }
      setShowAddConfirmationAlert(false);
      setShowToast(true);
    } catch (error) {
      console.error(error);
    }
  };

  //table filter section
  const handleFilter = (key: string, value: any) => {
    if (key === "search") {
      setkeyWord(value);
    } else if (key === "productionType") {
      setProductionType(value)
    } else if (key === "area") {
      setAreaId(value)
    } else if (key === "FromDate") {
      const formattedDate = value ? moment(value).format("YYYY-MM-DD 00:00:00") : "";
      setFromDate(formattedDate)
      setToDate("")
    } else if (key === "ToDate") {
      const formattedDate = value ? moment(value).format("YYYY-MM-DD 23:59:59") : "";
      setToDate(formattedDate)
    }else if (key === "ProductionStatus") {
    setProductionStatus(value);
  }
    setUseEffectRequired(true);
  };

  // function to sort table
  const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  // function to sort table
  const handleAddProTableSort = (key: string, value: boolean) => {
    setSort(key);
    let newOrder = order
    if (value) {
      setOrder("asc");
      newOrder = "asc"
    } else {
      setOrder("desc");
      newOrder = "desc"
    }
    // getFrequencyPreviewTableData({
    //   production_type: masterFormData?.production_type,
    //   area_id: masterFormData?.area_id,
    //   sort: key,
    //   order: newOrder
    // });
  };

  //handle table pagination
  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPage(newPage);
    if (pageSize) {
      setPageSize(pageSize);
    }
    setUseEffectRequired(true);
  };

  //open add area modal
  const handleAddClick = () => {
    setShowAddModal(true);
    setModalName(t("scheduleProduction.addProduction"));
    setFrequencyPreviewTableData([]);
  };

  // handle status change
  const handleStatusChange = (id: string, status: string) => {
    setSelectedId(id);
    if (status === "active") {
      setUpdatedStatus("inactive");
    } else {
      setUpdatedStatus("active");
    }
    setStatusChangeAlert(true);
  };

  //change area status api call
  const handleStatusChangeSubmit = async () => {
    try {
      const response = await scheduleService.changeProductionScheduleStatus(
        selectedId,
        updatedStatus,
        "Production Schedule"
      );

      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setToastMessage(response.message);
      } else {
        setToastType("error");
        setToastMessage(response.message);
      }
      setShowToast(true);
      setUseEffectRequired(true);
      setUpdatedStatus("");
      setSelectedId("");
      setStatusChangeAlert(false);
    } catch (error) {
      console.error(error);
    }
  };

  //filter selected id based on the row selected while editing
  const handleEditClick = (id: string) => {
    const row = tableData.filter((item) => item.slno === id);
    if (typeof row[0].area_id === 'string') {
      row[0].area_id = row[0].area_id.split(',');
    }
    if (_h.arrayHasData(row) && _h.objectHasValue(row[0])) {
      setMasterFormData(row[0]);
      setShowAddModal(true);
      setModalName(t("scheduleProduction.editProduction"));
      setFrequencyPreviewTableData([]);
      getListLocation(row[0]?.area_id)
      // getFrequencyPreviewTableData({
      //   area_id: row[0]?.area_id,
      //   production_type: row[0]?.production_type,
      //   sort: sort,
      //   order: order
      // });
    }
  };

  // handle view icon click
  const handleViewClick = (id: string, viewValue: boolean) => {
    const row = tableData.filter((item) => item.slno === id);
    if (_h.arrayHasData(row) && _h.objectHasValue(row[0])) {
      setSelectedRow(row[0]);
      setShowViewModal(true);
    }
  };

  // get table data
  const getProductionScheduleList = async () => {
    setTableData([{ loading: true }]);
    try {
      const response = await scheduleService.getProductionScheduleList(
        page,
        pageSize,
        sort,
        order,
        keyWord,
        fromDate,
        toDate,
        productionType,
        areaId,
        productionStatus
      );
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPages(response?.totalPages);
            setTotalElements(response?.totalElements);
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  activity_type_name: element.activity_type_name,
                  status: element.status,
                  activity_type_id: element.activity_type_id,
                  created_at: element?.created_at
                    ? moment(element?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY - HH:mm:ss"
                    )
                    : "-",
                  updated_at: element?.updated_at
                    ? moment(element?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY - HH:mm:ss"
                    )
                    : "-",
                  production_schedule_name: element?.production_schedule_name,
                  product_name: element?.schedule_product_name,
                  production_type: element?.production_type ? element.production_type.charAt(0).toUpperCase() + element.production_type.slice(1) : '',
                  area_id: element?.area_id,
                  from_date_time: element?.from_date_time
                    ? moment(
                      element?.from_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY")
                    : "-",
                  to_date_time: element?.to_date_time
                    ? moment(
                      element?.to_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY")
                    : "-",
                  area_name: element?.area_name,
                  area_grade_name: element?.area_grade_name,
                  is_completed: element?.is_completed === "1" ? "Completed" : "In Progress"
                };
              }
            );
            setTableData(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalElements(0);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get Activity Type List
  const getActivityTypeList = async () => {
    try {
      const response = await scheduleService.getActivityTypeList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setActivityType(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setActivityType([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get area list
  const getAreaList = async (areaTypeId : any, gradeTypeId: any) => {
    try {
      const response = await scheduleService.getAreaList(sort, order, areaTypeId, gradeTypeId);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                  grade_name: element.grade_name,
                };
              }
            );
            setAreaList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setAreaList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

   //api call to get area list
  const getListLocation = async (areaId: any) => {
    if(areaId.length > 0){
      try {
        const response = await areaService.getHeirarchyTypes("10,13,11,15,18,19,20,21,22", areaId);
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    id: element.id,
                    area_name: element.area_name,
                    name: element.location_type_name,
                    location_code: element.area_code,
                    location_name: element.name,
                  };
                }
              );
              setLocationList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setLocationList([]);
        }
      } catch (error) {
        console.error("user response", error);
      }
    } else {
      setLocationList([]);
    }
  };

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //clear modal on close - QR
  const handleQRGenerate = (row: any) => {
    setSelectedRow(row);
    setQrFormData(defaultQrFormData);
    getBatchList();
    getProductionOperators(row?.id);
    setShowGenerateQrModal(true);
  };

  //clear modal on close - QR
  const handleQRFormClose = () => {
    setQrFormData(defaultQrFormData);
    setSelectedRow(defaultFormData);
    setShowGenerateQrModal(false);
  };

  //handle onchange input QR fields
  const handleQRFieldOnChange = async (e: any) => {
    const { name, value } = e.target;

    if (name == "batchId") {
      let lots = await getLotList(value);
      setLotList(lots);
    }
    setQrFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  //handle single and multi QR download button click
  const handleQrDownload = async () => {
    const selectedOperators = opTableData.filter((item: any) =>
      selectedOpSlNo.includes(item.slno)
    );
    handleQRFormValidation(selectedOperators);
  };

  //handle area validation starts here
  const handleQRFormValidation = (selectedOperators: any[]) => {
    const errors: Errors = {};
    // if (!qrFormData.activity_type_id) {
    //   errors.activity_type_id = "Please select an activity type";
    // }
    if (!qrFormData.batchId) {
      errors.batchId = t("scheduleProduction.errors.batch");
    }
    if (!qrFormData.lotId) {
      errors.lotId = t("scheduleProduction.errors.lot");
    }
    // if (!qrFormData.nextSerialNo) {
    //   errors.nextSerialNo = "Please enter next serial No";
    // }
    // if (!qrFormData.plateCount) {
    //   errors.plateCount = "Please enter plate count";
    // }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    if (!_h.arrayHasData(selectedOperators)) {
      setToastType("error");
      setToastMessage(t("scheduleProduction.errors.operator"));
      setShowToast(true);
      return;
    }
    setErrors({});
    handleQRFormSubmit(selectedOperators);
  };

  //handle add area submit api call
  const handleQRFormSubmit = async (selectedOperators: any[]) => {
    if (_h.isNotEmpty(selectedOperators)) {
      // let i = 0;
      let totalQuantity = 0;
      let request: any = [];
      Object.values(selectedOperators).forEach(async (val) => {
        request.push({
          lot_id: qrFormData.lotId,
          quantity: val.plateCount,
          master_activity_id: val?.activity_type_id,
          location_id: val.location_id,
          operator_id: val.user_master_id,
          schedule_operator_id: val.id,
        });
        totalQuantity += val.plateCount;
        // const dataToSend = {
        //   lot_id: qrFormData.lotId,
        //   quantity: val.plateCount,
        //   master_activity_id: val?.activity_type_id,
        //   location_id: val.location_id,
        //   operator_id: val.user_master_id,
        //   schedule_operator_id: val.id,
        // };
        // try {
        //   const response = await scheduleService.generatePlateQr(dataToSend);
        //   if (response.status && response.statusCode === 200) {
        //     i++;
        //     if (selectedOperators.length <= i) {
        //       setToastType("success");
        //       setToastMessage(response.message);
        //       getProductionOperators(selectedRow?.id);
        //       setShowToast(true);
        //       // handleFormClose();
        //     }
        //   } else {
        //     setToastType("error");
        //     setToastMessage(response.message);
        //     getProductionScheduleList();
        //     setShowToast(true);
        //     return;
        //   }
        // } catch (error) {
        //   console.error(error);
        //   getProductionScheduleList();
        // }
      });
      try {
        const response = await scheduleService.generateBulkPlateQr({
          operators: request,
          lot_id: qrFormData.lotId,
          totalQuantity: totalQuantity,
          interface_name: modalName,
        });
        if (response.status && response.statusCode === 200) {
          setToastType("success");
          setToastMessage(response.message);
        } else {
          setToastType("error");
          setToastMessage(response.message);
        }
        getProductionOperators(selectedRow?.id);
        setShowToast(true);
      } catch (error) {
        console.error(error);
        getProductionScheduleList();
      }
    }
  };

  //api call to get batch list
  const getBatchList = async () => {
    try {
      const response = await scheduleService.getBatchList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.batch_no,
                };
              }
            );
            setBatchList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setBatchList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get lot list
  const getLotList = async (batchId: string) => {
    let rowData: any = [];
    try {
      const response = await scheduleService.getLotList(
        _h.isNotEmpty(batchId) ? batchId : defaultQrFormData?.batchId
      );
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            rowData = response.data.map((element: any, index: number) => {
              return {
                id: element.id,
                name: element.lot_code,
              };
            });
            setLotList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setLotList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
    return rowData;
  };

  // get table data
  const getProductionOperators = async (schedule_production_id: string) => {
    try {
      const response = await scheduleService.getProductionOperators({
        schedule_production_id: _h.isNotEmpty(selectedRow?.id)
          ? selectedRow?.id
          : schedule_production_id,
      });
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setOpTotalPages(response?.totalPages);
            setOpTotalElements(response?.totalElements);
            let plateCount = 0;
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                plateCount += parseInt(element?.plateCount);
                return {
                  slno: index + 1,
                  id: element.id,
                  plateCount: element?.plateCount,
                  location_name: element?.location_name || "-",
                  location_id: element?.location_id,
                  status: element.status,
                  activity_type_id: element.activity_type_id,
                  created_at: element?.created_at
                    ? moment(element?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY - HH:mm:ss"
                    )
                    : "-",
                  updated_at: element?.updated_at
                    ? moment(element?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY - HH:mm:ss"
                    )
                    : "-",
                  schedule_production_id: element?.schedule_production_id,
                  start_date_time: element?.start_date_time
                    ? moment(
                      element?.start_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY - HH:mm:ss")
                    : "-",
                  end_date_time: element?.end_date_time
                    ? moment(
                      element?.end_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY - HH:mm:ss")
                    : "-",
                  process_id: element?.process_id,
                  user_master_id: element?.user_master_id,
                  created_by: element?.created_by,
                  updated_by: element?.updated_by,
                  production_schedule_name: element?.production_schedule_name,
                  product_name: element?.schedule_product_name,
                  production_type: element?.production_type,
                  user_first_name: element?.user_first_name,
                  user_last_name: element?.user_last_name,
                  operator_name: (
                    (element?.user_first_name).trim() +
                    " " +
                    (element?.user_last_name).trim()
                  ).trim(),
                  process_name: element?.process_name,
                  activity_type_name: element?.activity_type_name,
                  work_shift_name: element?.work_shift_name,
                };
              }
            );
            setTotalPlateCount(plateCount);
            setOpTableData(rowData);
          } else {
            setTotalPlateCount(0);
            setOpTableData([]);
          }
        } catch (error) {
          setTotalPlateCount(0);
          setOpTableData([]);
        }
      } else {
        setTotalPlateCount(0);
        setOpTableData([]);
      }
    } catch (error) {
      console.error("user response", error);
      setTotalPlateCount(0);
      setOpTableData([]);
    }
  };

  //handle op table pagination
  const handleOpPageChange = (newPage: any, pageSize?: number) => {
    setOpPage(newPage);
    if (pageSize) {
      setOpPageSize(pageSize);
    }
    getProductionOperators("");
  };

  //  on selecting production list
  const addProductionActionClick = (slno: string[]) => {
    const filteredPlateDetailsIds: any = frequencyPreviewTableData
      .filter((item: any) => slno.includes(item.slno))
      .map((item: any) => Number(item.id));
    setSelectedOperatorIds(filteredPlateDetailsIds)
  }

  //handle download qr button
  const handleDownloadBtn = () => {
    const content: any = document.getElementById("innerDiv");
    const pri: any = window.open("", "", "height=600,width=800");
    pri.document.write(content.innerHTML);
    pri.onafterprint = () => {
      pri.close();
      setQrModalShow(false);
    };
    pri.print();
  };

  //create grid for qr section
  const createGrid = () => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {qrFiles.map((cellIndex: any, index: number) => (
          <div
            key={index}
            style={{
              border: "0.5px solid grey",
              margin: "15px 15px",
              alignItems: "center",
            }}
          >
            <img
              src={baseUrl + "/" + cellIndex?.qr_file_path}
              alt={`Image ${cellIndex?.production_schedule_name}`}
              style={{
                width: `${cellWidth}cm`,
                height: `${cellWidth}cm`,
                pageBreakInside: "avoid",
              }}
            />
            <p
              style={{
                fontSize: `${cellWidth + 10}px`,
                fontWeight: "400",
                margin: "2%",
                textAlign: "center",
              }}
            >
              {/* Production: <u>{cellIndex?.production_schedule_name}</u>
              <br></br>
              Activity: <u>{cellIndex?.activity_type_name}</u>
              <br></br>
              Process: <u>{cellIndex?.process_name}</u>
              <br></br> */}
              {cellIndex?.location_name}
              <br></br>
              {cellIndex?.user_first_name + " " + cellIndex?.user_last_name}
              <br></br>
              {cellIndex?.serial_number}
              {/* Use Within:{" "}
              <u>
                {moment(
                  cellIndex.start_date_time,
                  "YYYY-MM-DD HH:mm:ss"
                ).format("DD-MM-YYYY - HH:mm:ss") +
                  " and " +
                  moment(cellIndex.end_date_time, "YYYY-MM-DD HH:mm:ss").format(
                    "DD-MM-YYYY - HH:mm:ss"
                  )}
              </u> */}
            </p>
          </div>
        ))}
      </div>
    );
  };

  const handleSelectChange = (event: any) => {
    const { name, value } = event.target;
    let newValue = value;

    // Handle "Select All" toggle
    if (value.includes('ALL')) {
      newValue = isAllSelected ? [] : allAreaNames;
    }

    handleFieldOnChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  const [showCompleteConfirm, setShowCompleteConfirm] = useState(false);
  const [selectedSchedulesToComplete, setSelectedSchedulesToComplete] = useState<string[]>([]);
  const [selectedScheduleDates, setSelectedScheduleDates] = useState<{
    from: string | null;
    to: string | null;
  }>({ from: null, to: null });

  const getCompletionMessage = () => {
    if (selectedSchedulesToComplete.length > 1) {
      const now = moment();
      const inProgressSchedules: {endDate: string}[] = [];
      const endedSchedules: {endDate: string}[] = [];
      const completedSchedules: {endDate: string}[] = [];
      const upcomingSchedules: {startDate: string}[] = [];

      selectedSchedulesToComplete.forEach(slno => {
        const schedule = tableData.find(item => item.slno === slno);
        if (!schedule) {
          console.log(`Schedule ${slno} not found in tableData`);
          return;
        }

        try {
          const fromDate = moment(schedule.from_date_time, 'DD-MM-YYYY');
          const toDate = moment(schedule.to_date_time, 'DD-MM-YYYY');
          const formattedDate = toDate.isValid() ? toDate.format('MMM D, YYYY') : 'Unknown date';
          
          // Check if explicitly marked as completed
          const isCompleted = schedule.is_completed === 1 || 
                            schedule.is_completed === '1' || 
                            schedule.is_completed === 'Completed';

          if (isCompleted) {
            completedSchedules.push({ endDate: formattedDate });
            return;
          }
          
          // Skip inactive schedules
          if (schedule.status === 'inactive') {
            return;
          }

          // Handle date-based statuses
          if (!fromDate.isValid() || !toDate.isValid()) {
            console.error(`Invalid dates for schedule ${slno}:`, {
              from: schedule.from_date_time,
              to: schedule.to_date_time
            });
            return;
          }

          if (now.isBefore(fromDate, 'day')) {
            upcomingSchedules.push({ startDate: fromDate.format('MMM D, YYYY') });
          } else if (now.isAfter(toDate, 'day')) {
            endedSchedules.push({ endDate: formattedDate });
          } else {
            // Either in progress or explicitly marked as 'In Progress'
            if (schedule.is_completed === 'In Progress' || now.isSameOrBefore(toDate, 'day')) {
              inProgressSchedules.push({ endDate: formattedDate });
            }
          }
          
        } catch (error) {
          console.error('Error processing schedule', slno, error, {
            from: schedule?.from_date_time,
            to: schedule?.to_date_time,
            status: schedule?.status,
            is_completed: schedule?.is_completed
          });
        }
      });
      
      const completedCount = completedSchedules.length;
      
      // Create detailed status messages
      const statusMessages = [];
      
      // Group in-progress schedules by end date
      if (inProgressSchedules.length > 0) {
        const grouped = inProgressSchedules.reduce((acc, s) => {
          acc[s.endDate] = (acc[s.endDate] || 0) + 1;
          return acc;
        }, {} as {[key: string]: number});
        
        const dateStrings = Object.entries(grouped).map(([date, count]) => 
          `${count} ${count > 1 ? 'ending' : 'ends'} on ${date}`
        );
        
        if (dateStrings.length > 0) {
          statusMessages.push(`${inProgressSchedules.length} in-progress schedule${inProgressSchedules.length > 1 ? 's' : ''} `);
        }
      }
      
      // Group ended schedules by end date
      if (endedSchedules.length > 0) {
        const grouped = endedSchedules.reduce((acc, s) => {
          acc[s.endDate] = (acc[s.endDate] || 0) + 1;
          return acc;
        }, {} as {[key: string]: number});
        
        const dateStrings = Object.entries(grouped).map(([date, count]) => 
          `${count} on ${date}`
        );
        
        if (dateStrings.length > 0) {
          statusMessages.push(`${endedSchedules.length} schedule${endedSchedules.length > 1 ? 's' : ''} with end date passed `);
        }
      }
      
      // Add upcoming schedules with start dates
      if (upcomingSchedules.length > 0) {
        const grouped = upcomingSchedules.reduce((acc, s) => {
          acc[s.startDate] = (acc[s.startDate] || 0) + 1;
          return acc;
        }, {} as {[key: string]: number});
        
        const dateStrings = Object.entries(grouped).map(([date, count]) => 
          `${count} starting ${date}`
        );
        
        if (dateStrings.length > 0) {
          statusMessages.push(`${upcomingSchedules.length} upcoming schedule${upcomingSchedules.length > 1 ? 's' : ''} `);
        }
      }
      
      // Add completed count without dates
      if (completedCount > 0) {
        statusMessages.push(`${completedCount} completed schedule${completedCount > 1 ? 's' : ''}`);
      }
      
      // Determine which message to show based on schedule statuses
      const hasEndDateNotReached = inProgressSchedules.length > 0 || upcomingSchedules.length > 0;
      const hasEndDateReached = endedSchedules.length > 0;
      
      if (hasEndDateNotReached && hasEndDateReached) {
        return 'End this Production Schedule. For some schedules End date has not been reached.';
      } else if (hasEndDateNotReached) {
        return 'End this Production Schedule. End date has not been reached.';
      } else if (hasEndDateReached) {
        return 'End this Production Schedule.';
      } else if (completedCount > 0) {
        return `Complete ${completedCount} selected completed schedule${completedCount > 1 ? 's' : ''}?`;
      } else {
        return `Complete ${selectedSchedulesToComplete.length} selected production schedule${selectedSchedulesToComplete.length > 1 ? 's' : ''}?`;
      }
    }
  
    // Single schedule selection logic remains the same
    if (!selectedScheduleDates.from || !selectedScheduleDates.to) return "Complete this schedule?";
    
    try {
      const fromDate = moment(selectedScheduleDates.from, 'DD-MM-YYYY - HH:mm:ss');
      const toDate = moment(selectedScheduleDates.to, 'DD-MM-YYYY - HH:mm:ss');
      const now = moment();
      
      if (now.isBefore(fromDate)) {
        return `End this Production Schedule.End date has not been reached.`;
      } else if (now.isBefore(toDate) || now.isSame(toDate, 'day')) {
        return `End this Production Schedule.End date has not been reached.`;
      }
    } catch (error) {
      console.error('Error parsing dates:', error);
    }
    
    return "End this Production Schedule.";
  };

  const handleCompleteConfirm = async () => {
    await completeProduction(selectedSchedulesToComplete);
    setShowCompleteConfirm(false);
  };

  const ChangeCompletedStatus = (slno: string[]) => {
    const selectedSchedule = tableData.find(item => item.slno === slno[0]);
    if (selectedSchedule) {
      setSelectedSchedulesToComplete(slno);
      setSelectedScheduleDates({
        from: selectedSchedule.from_date_time || null,
        to: selectedSchedule.to_date_time || null
      });
      setShowCompleteConfirm(true);
    }
  };

  const completeProduction = async (slno: string[]) => {
    const selectedSchedules = tableData.filter(item => slno.includes(item.slno));

    if (selectedSchedules.length === 0) {
      setToastType("error");
      setToastMessage("No schedules selected");
      setShowToast(true);
      return;
    }

    // Check if any selected schedule is already completed
    const completedSchedules = selectedSchedules.filter(
      schedule => schedule.is_completed === '1' || 
              schedule.status === 'Completed' || 
              schedule.is_completed === 1 ||
              schedule.is_completed === 'Completed'
    );

    if (completedSchedules.length > 0) {
      const scheduleNames = completedSchedules
        .map(schedule => schedule.production_schedule_name || 'Unnamed Schedule')
        .join(', ');
      
      setToastType("error");
      setToastMessage(`Cannot proceed: The following schedule(s) are already marked as completed: ${scheduleNames}. Please select In progress Schedules to Proceed.`);
      setShowToast(true);
      return;
    }

    const dataToSend = {
      is_completed: 1,
      interface_name: "Production Schedule",
      production_schedule_name: selectedSchedules.map(schedule => 
        schedule.production_schedule_name
      ).join(","),

    };

    try {
      setLoader(true);
      const response = await scheduleService.changeCompleteStatus(dataToSend);
      
      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setToastMessage("Schedules marked as completed");
        getProductionScheduleList();
        setSelectedOpSlNo([]);
      } else {
        setToastType("error");
        setToastMessage(response.message || "Failed to complete schedules");
      }
      setShowToast(true);
    } catch (error) {
      console.error("Error completing schedules:", error);
      setToastType("error");
      setToastMessage("An error occurred while completing schedules");
      setShowToast(true);
    } finally {
      setLoader(false);
    }
  };

  // useEffect(() => {
  //   if (!masterFormData.area_id?.length) {
  //     handleFieldOnChange({
  //       target: {
  //         name: 'area_id',
  //         value: areaList.map((val: any) => val.id),
  //       },
  //     });
  //   }
  // }, [areaList]);

  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t("scheduleProduction.pageTitle")} />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      {tab === "1" && (
        <div className="me-3" style={{ marginTop: "10px" }}>
          <div className=" mx-3 pe-2" style={{ height: "45vh" }}>
            <CustomTable
              tableHead={t("scheduleProduction.tableHead")}
              data={tableData}
              columns={columns}
              // isEditable={permission?.includes("edit_production_schedule")}
              isEditable={false}
              totalElements={totalElements}
              isActionVisible={true}
              isViewVisible={true}
              onViewClick={handleViewClick}
              isSeachable={true}
              addButton={permission?.includes("add_production_schedule")}
              addButtonText={t("scheduleProduction.add")}
              onFilterClick={handleFilter}
              onSortClick={handleSort}
              onAddClick={handleAddClick}
              actionCheckOrangeButton3={true}
              actionCheckOrangeBtnText3={"Production Completed"}
              onActionCheckOrangeButtonClick3={ChangeCompletedStatus}
              isToggleStatus={true}
              onStatusChange={handleStatusChange}
              isQrDownloadable={false}
              onEditClick={handleEditClick}
              showQrGenerateButton={false}
              areaDropList={areaList}
              showToDateFilter={true}
              showFromDateFilter={true}
              dateType='date'
              onBlueBtnClick={() => setTab("2")}
              blueBtnText={t("scheduleProduction.productionCalendar")}
              showBlueBtn={permission?.includes("view_production_calendar")}
              removeSortList={sortRemoveList}
              showFullFilters={true}
              productionStatus={productionStatus}
            />
          </div>
          <div>
            <Pagination
              page={page}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      )}

      {tab === "2" && (
        <ViewSchedule setTab={setTab} />
      )}


      {/* Alert modal for Add/edit Schedule */}
      {loader ? <CustomLoader /> :
        <AlertModal
          show={showAddConfirmationAlert}
          onHide={() => setShowAddConfirmationAlert(false)}
          title={t("common.alert")}
          message={modalName}
          onConfirm={handleFormSubmit}
        />
      }

      {/* Alert modal for change Schedule status */}
      <AlertModal
        show={statusChangeAlert}
        onHide={() => setStatusChangeAlert(false)}
        title={t("common.alert")}
        message={t("scheduleProduction.changeProductionStatus")}
        onConfirm={handleStatusChangeSubmit}
      />

      {/*modal for Add/edit Schedule */}
      <Modal
        className="top-right-modal-lg"
        centered={false}
        show={showAddModal}
        size='lg'
      >
        {loader && <CustomLoader />}
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">{modalName}</p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleFormClose()}
              className="p-2 mx-3 my-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>
          <div style={{"overflow":"scroll", "height": "80vh"}}>
            <div className="selectWrap-new">
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.production_schedule_name")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  id="production_schedule_name"
                  value={masterFormData.production_schedule_name}
                  name="production_schedule_name"
                  type="text"
                  placeholder={t("scheduleProduction.production_schedule_name")}
                  className="placeholder-style"
                  onChange={handleFieldOnChange}
                />
                {errors.production_schedule_name && (
                  <p className="errorText">{errors.production_schedule_name}</p>
                )}
              </div>
              
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.production_type")}
                  <span style={{ color: "red" }}>*</span>
                </label>

                <br />
                {/* <input
                  id="production_type"
                  value={masterFormData.production_type}
                  name="production_type"
                  type="text"
                  placeholder={t("scheduleProduction.production_type")}
                  className="filter-input"
                  onChange={handleFieldOnChange}
                /> */}
                <select
                  id="production_type"
                  value={masterFormData?.production_type}
                  name="production_type"
                  onChange={handleFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  <option key={"operational"} value={"operational"}>
                    {"Operational"}
                  </option>
                  <option key={"non-operational"} value={"non-operational"}>
                    {"Non-operational"}
                  </option>
                  {/* <option key={"ongoing"} value={"ongoing"}>
                    {"Ongoing"}
                  </option> */}
                </select>
                {errors.production_type && (
                  <p className="errorText">{errors.production_type}</p>
                )}
              </div>

              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.product_name")}
                  <span style={{ color: "red" }}></span>
                </label>
                <br />
                {/* <input
                  id="product_name"
                  value={masterFormData.product_name}
                  name="product_name"
                  type="text"
                  placeholder={t("scheduleProduction.product_name")}
                  className="placeholder-style"
                  onChange={handleFieldOnChange}
                /> */}
                 <select
                  id="product_name"
                  value={masterFormData?.product_name}
                  name="product_name"
                  onChange={handleFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {productList.map((val) => (
                    <option key={val.id} value={val.name}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {errors.product_name && (
                  <p className="errorText">{errors.product_name}</p>
                )}
              </div>
              {/* area type */}
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.areaType")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id="areaType"
                  value={masterFormData?.areaType}
                  name="areaType"
                  onChange={handleFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {areaType.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.title}
                    </option>
                  ))}
                </select>
                {errors.areaType && <p className="errorText">{errors.areaType}</p>}
              </div>

              {/* grade type */}
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.gradeType")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id="gradeType"
                  value={masterFormData?.gradeType}
                  name="gradeType"
                  onChange={handleFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {grade.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.grade}
                    </option>
                  ))}
                </select>
                {errors.gradeType && <p className="errorText">{errors.gradeType}</p>}
              </div>

            </div>
            <div className="selectWrap-new">
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.area")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                {/* <select
                  id="area_id"
                  value={masterFormData?.area_id}
                  name="area_id"
                  onChange={handleFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {areaList.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select> */}
                <FormControl sx={{width: 195}}>
                 <Select
                  multiple
                  displayEmpty
                  value={masterFormData?.area_id}
                  onChange={handleSelectChange}
                  name="area_id"
                  input={<OutlinedInput/>}
                  sx={{height: 38, paddingTop: 2}}
                  inputProps={{ 'aria-label': 'Without label' }}
                  // MenuProps={MenuProps}
                >
                  <MenuItem 
                    value="ALL"
                    sx={{
                        backgroundColor: isAllSelected ? '#e3f2fd' : 'inherit',
                        '&.Mui-selected': {
                          backgroundColor: '#bbdefb',
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: '#90caf9',
                        },
                      }}
                  >
                    Select All
                  </MenuItem>

                  {areaList.map((val: any) => {
                    const isSelected = masterFormData.area_id.includes(val.id);
                    return (
                      <MenuItem
                        key={val.id}
                        value={val.id}
                          sx={{
                          backgroundColor: isSelected ? '#e3f2fd' : 'inherit',
                          '&.Mui-selected': {
                            backgroundColor: '#bbdefb',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: '#90caf9',
                          },
                        }}
                      >
                        {val.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                </FormControl>
                {errors.area_id && <p className="errorText">{errors.area_id}</p>}
              </div>

              {/* <div className="form-group my-1 mx-3 px-2">
                <label>{t("scheduleProduction.area_grade_name")}</label>
                <br />
                <input
                  id="area_grade_name"
                  value={masterFormData.area_grade_name}
                  name="area_grade_name"
                  type="text"
                  placeholder={t("scheduleProduction.selectArea")}
                  className="placeholder-style"
                  disabled={true}
                />
              </div> */}
              <div className="form-group my-1 mx-3 px-2" style={{ "width": "208px" }}>
                <label>
                  {t("scheduleProduction.from_date_time")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  type="date"
                  name="from_date_time"
                  id="from_date_time"
                  value={
                    _h.isNotEmpty(masterFormData.from_date_time)
                      ? moment(
                        masterFormData.from_date_time,
                        "DD-MM-YYYY - HH:mm:ss"
                      ).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={handleFieldOnChange}
                  className="filter-input"
                  min={moment(currentDate).format("YYYY-MM-DD")}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Tab",
                      "Enter",
                      "Escape",
                    ];
                    if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => e.preventDefault()}
                />
                {errors.from_date_time && (
                  <p className="errorText">{errors.from_date_time}</p>
                )}
              </div>
              <div className="form-group my-1 mx-3 px-2" style={{ "width": "208px" }}>
                <label>
                  {t("scheduleProduction.to_date_time")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  type="date"
                  name="to_date_time"
                  id="to_date_time"
                  value={
                    _h.isNotEmpty(masterFormData.to_date_time)
                      ? moment(
                        masterFormData.to_date_time,
                        "DD-MM-YYYY - HH:mm:ss"
                      ).format("YYYY-MM-DD")
                      : ""
                  }
                  min={_h.isNotEmpty(masterFormData.from_date_time)
                    ? moment(
                      masterFormData.from_date_time,
                      "DD-MM-YYYY"
                    ).format("YYYY-MM-DD")
                    : ""}
                  onChange={handleFieldOnChange}
                  className="filter-input"
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Tab",
                      "Enter",
                      "Escape",
                    ];
                    if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => e.preventDefault()}
                />
                {errors.to_date_time && (
                  <p className="errorText">{errors.to_date_time}</p>
                )}
              </div>

              {masterFormData.id && (
                <div className="form-group my-1 mx-3 px-2">
                  <label htmlFor="" className="ReasonLabel">
                    {t("userManagement.reason")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <input
                    id="reason"
                    value={masterFormData.reason}
                    name="reason"
                    type="text"
                    placeholder={t("userManagement.reason")}
                    className="reasonClass"
                    onChange={handleFieldOnChange}
                    onKeyDown={(e) => helperFunctions.textFieldValidationCheck(e)}
                  />
                  {errors.reason && <p className="errorText">{errors.reason}</p>}
                </div>
              )}
            </div>
            <div >
              <div className=" mx-3 pe-2" style={{ height: "45vh" }}>
                <CustomTable
                  tableHead={t("scheduleProduction.activityFrequencies")}
                  data={locationList}
                  columns={activityFrequencyColumns}
                  isEditable={false}
                  totalElements={locationList.length}
                  isActionVisible={false}
                  isViewVisible={false}
                  // onViewClick={handleViewClick}
                  isSeachable={false}
                  // addButton={permission?.includes("add_production_schedule")}
                  // addButtonText={t("scheduleProduction.add")}
                  // onFilterClick={handleFilter}
                  onSortClick={handleAddProTableSort}
                  // onAddClick={handleAddClick}
                  isToggleStatus={false}
                  // onStatusChange={handleStatusChange}
                  isQrDownloadable={false}
                  // onEditClick={handleEditClick}
                  showQrGenerateButton={false}
                  onActionClick={addProductionActionClick}
                />
              </div>
            </div>
          </div>
          <div className="bottomArea">
            <button
              onClick={() => handleFormClose()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => handleFormValidation()}
              className="squareOrangeBtn3"
            >
              {t("buttons.submit")}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        show={showViewModal}
        className="modal-view-audit"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
      >
        <Modal.Header closeButton onClick={() => setShowViewModal(false)}>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("scheduleProduction.view")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 style={{ textAlign: "left" }}>
            {t("scheduleProduction.scheduleProductionDetails")}
          </h4>
          {_h.objectHasValue(selectedRow) && (
            <>
              <div
                className="key-value-pairs"
                style={{
                  display: "flex",
                  padding: "10px",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t(
                      "scheduleProduction.tableColumns.production_schedule_name"
                    )}
                  </div>
                  <div className="audit-value">
                    {selectedRow?.production_schedule_name}
                  </div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.product_name")}
                  </div>
                  <div className="audit-value">{selectedRow?.product_name}</div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.production_type")}
                  </div>
                  <div className="audit-value">
                    {selectedRow?.production_type}
                  </div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.from_date_time")}
                  </div>
                  <div className="audit-value">
                    {selectedRow?.from_date_time}
                  </div>
                </div>
              </div>
              <div
                className="key-value-pairs"
                style={{
                  display: "flex",
                  padding: "10px",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.to_date_time")}
                  </div>
                  <div className="audit-value">{selectedRow?.to_date_time}</div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.area_name")}
                  </div>
                  <div className="audit-value">{selectedRow?.area_name}</div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.area_grade_name")}
                  </div>
                  <div className="audit-value">
                    {selectedRow?.area_grade_name}
                  </div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.created_at")}
                  </div>
                  <div className="audit-value">{selectedRow?.created_at}</div>
                </div>
              </div>
              <div
                className="key-value-pairs"
                style={{
                  display: "flex",
                  padding: "10px",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.tableColumns.updated_at")}
                  </div>
                  <div className="audit-value">{selectedRow?.updated_at}</div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {t("scheduleProduction.status")}
                  </div>
                  <div className="audit-value">{selectedRow?.status}</div>
                </div>
                <div className="column" style={{ flex: "1" }}>
                  <div className="audit-key">
                    {"Production Status"}
                  </div>
                  <div className="audit-value">{selectedRow?.is_completed}</div>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-start">
          <button
            onClick={() => setShowViewModal(false)}
            className="custom-close-button"
          >
            {t("buttons.close")}
          </button>
        </Modal.Footer>
      </Modal>

      {/*modal for generate QR */}
      <Modal
        className="top-right-modal-md"
        centered={false}
        show={showGenerateQrModal}
      // size='lg'
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">
              {t("scheduleProduction.downloadGenerateQr")}
            </p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleQRFormClose()}
              className="p-2 mx-3 my-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>
          <div className="selectWrap-new">
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleProduction.batch")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select
                id="batchId"
                name="batchId"
                onChange={handleQRFieldOnChange}
              >
                <option value="">{t("common.select")}</option>
                {batchList.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.batchId && <p className="errorText">{errors.batchId}</p>}
            </div>
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleProduction.lot")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select id="lotId" name="lotId" onChange={handleQRFieldOnChange}>
                <option value="">{t("common.select")}</option>
                {lotList.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.lotId && <p className="errorText">{errors.lotId}</p>}
            </div>
            {/* <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleProduction.nextSerialNo")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <input
                id="nextSerialNo"
                name="nextSerialNo"
                type="text"
                placeholder={t("scheduleProduction.nextSerialNo")}
                className="filter-input"
                onChange={handleQRFieldOnChange}
              />
              {errors.nextSerialNo && (
                <p className="errorText">{errors.nextSerialNo}</p>
              )}
            </div> */}
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleProduction.totalPlatesNeeded")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <input
                id="plateCount"
                name="plateCount"
                type="text"
                placeholder={t("scheduleProduction.totalPlatesNeeded")}
                className="filter-input"
                onChange={handleQRFieldOnChange}
                disabled={true}
                value={totalPlateCount}
              />
              {errors.plateCount && (
                <p className="errorText">{errors.plateCount}</p>
              )}
            </div>
          </div>
          {/* <div className="selectWrap-new">
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleProduction.activityType")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select
                id="activity_type_id"
                name="activity_type_id"
                onChange={handleQRFieldOnChange}
                disabled={true}
                value={selectedRow?.activity_type_id}
              >
                <option value="">select</option>
                {activityType.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.activity_type_id && (
                <p className="errorText">{errors.activity_type_id}</p>
              )}
            </div>
          </div> */}

          <div className="me-3" style={{ marginTop: "10px" }}>
            <div className="mx-3 pe-2">
              <CustomTable
                tableHead={t("scheduleProduction.productionOperators")}
                data={opTableData}
                columns={opColumns}
                isEditable={false}
                totalElements={opTotalElements}
                isActionVisible={true}
                isViewVisible={false}
                isSeachable={false}
                addButton={false}
                isToggleStatus={false}
                isQrDownloadable={false}
                showQrGenerateButton={false}
                // isQrDownloadable={true}
                // onEditClick={handleEditClick}
                // onQrDownloadClick={handleQrDownload}
                onActionClick={(val) => {
                  setSelectedOpSlNo(val);
                }}
              />
            </div>
            <div>
              <Pagination
                page={opPage}
                totalPages={opTotalPages}
                handlePageChange={handleOpPageChange}
              />
            </div>
          </div>

          <div className="bottomArea">
            <button
              onClick={() => handleQRFormClose()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => handleQrDownload()}
              className="squareOrangeBtn3"
            >
              {t("buttons.generatePlateQR")}
            </button>
          </div>
        </div>
      </Modal>

      {/*modal for download QR*/}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={qrModalShow}
      >
        <Modal.Header closeButton onClick={() => setQrModalShow(false)}>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("buttons.download_qr")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Selected {selectedSlnoLen} plate(s) for download QR</p>
          <div className="selectWrap">
            <div className="form-group my-1">
              <label>{t("areaManagement.cell_width")}</label>
              <br />
              <input
                type="number"
                id="cellWidth"
                value={cellWidth}
                min="1"
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  if (value > 0) {
                    setCellWidth(value); // Update state only if value is greater than zero
                  }
                }}
              />
            </div>
          </div>
          <div
            id="innerDiv"
            hidden
            style={{
              border: "1px solid black",
              padding: "5px",
              margin: "5px",
              overflow: "scroll",
              height: "80vh",
            }}
          >
            {createGrid()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => handleDownloadBtn()}>
            {t("buttons.submit")}
          </Button>
        </Modal.Footer>
      </Modal>
      <AlertModal
        show={showCompleteConfirm}
        onHide={() => setShowCompleteConfirm(false)}
        title={t("common.alert")}
        message={getCompletionMessage()}
        onConfirm={handleCompleteConfirm}
      />
    </div>
  );
};

export default ScheduleProduction2;
